import React from "react";
import {AnalyticsOverview} from "../../components/Analytics/AnalyticsOverview";
import {campaignOverview} from "../../util/DemoData";

const DemoAnalyticsOverviewPage: React.FC = () => {


    const campaigns = campaignOverview
    return (
        <AnalyticsOverview campaigns={campaigns} demo={true}/>
    )
}

export default DemoAnalyticsOverviewPage
